import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
const TypographyElement = ({ children, dataTestId, as: Component = 'div', className, defaultClassName, }) => (_jsx(Component, { "data-testid": dataTestId, className: [defaultClassName, className].filter(Boolean).join(' '), children: children }));
export const H1 = (_a) => {
    var { as = 'h1' } = _a, props = __rest(_a, ["as"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: 'nucleus-font-sans nucleus-text-h1 nucleus-font-light nucleus-m-0' })));
};
export const H2 = (_a) => {
    var { as = 'h2' } = _a, props = __rest(_a, ["as"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: 'nucleus-font-sans nucleus-text-h2 nucleus-font-normal nucleus-m-0' })));
};
export const H3 = (_a) => {
    var { as = 'h3' } = _a, props = __rest(_a, ["as"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: 'nucleus-font-sans nucleus-text-h3 nucleus-font-normal nucleus-m-0' })));
};
export const H4 = (_a) => {
    var { as = 'h4' } = _a, props = __rest(_a, ["as"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: 'nucleus-font-sans nucleus-text-h4 nucleus-font-normal nucleus-m-0' })));
};
export const H5 = (_a) => {
    var { as = 'h5' } = _a, props = __rest(_a, ["as"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: 'nucleus-font-sans nucleus-text-h5 nucleus-font-semibold nucleus-m-0' })));
};
export const H6 = (_a) => {
    var { as = 'h6' } = _a, props = __rest(_a, ["as"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: 'nucleus-font-sans nucleus-text-h6 nucleus-font-normal nucleus-m-0' })));
};
export const Text = (_a) => {
    var { as = 'p', size = 'base' } = _a, props = __rest(_a, ["as", "size"]);
    return (_jsx(TypographyElement, Object.assign({}, props, { as: as, defaultClassName: `nucleus-font-sans nucleus-m-0 ${{
            xxs: 'nucleus-text-xxs',
            xs: 'nucleus-text-xs',
            sm: 'nucleus-text-sm',
            base: 'nucleus-text-base',
            lg: 'nucleus-text-lg',
        }[size]}` })));
};
//# sourceMappingURL=typography.js.map